var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "filter-list",
      staticStyle: { width: "100%" },
      attrs: { id: _vm.id },
    },
    [
      _c("div", { staticClass: "filter-label" }, [
        _c("label", { staticClass: "mr-1 ml-2" }, [
          _vm._v(_vm._s(_vm.$t(`staff.filters`, [_vm.filterData.length]))),
        ]),
      ]),
      _c(
        "b-dropdown",
        {
          staticClass: "history-dropdown",
          scopedSlots: _vm._u([
            {
              key: "button-content",
              fn: function () {
                return [
                  _c("div", { staticClass: "add-filter-placeholder" }),
                  _c(
                    "button",
                    {
                      staticClass: "add-filter btn-action",
                      attrs: { id: `BADGE_FILTER_ADD_${_vm.id}` },
                      on: { click: _vm.filterAdd },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["far", "plus"] },
                      }),
                      _c("b-popover", {
                        attrs: {
                          target: `BADGE_FILTER_ADD_${_vm.id}`,
                          placement: "top",
                          boundary: "viewport",
                          triggers: "hover",
                          content: _vm.$t("button.filter_add"),
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "b-dropdown-group",
            { attrs: { header: _vm.$t("recent") } },
            _vm._l(_vm.history, function (value, index) {
              return _c(
                "b-dropdown-item",
                {
                  key: index,
                  on: {
                    click: function ($event) {
                      return _vm.historyClicked(value)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(value.name) + " ")]
              )
            }),
            1
          ),
        ],
        1
      ),
      _c("BadgeGroup", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ item, index }) {
              return [
                _c("Badge", {
                  key: `${index}`,
                  attrs: {
                    text: item.name,
                    variant: "primary",
                    pillable: !!item.pillable,
                  },
                  on: {
                    badgeRemove: function ($event) {
                      return _vm.badgeRemove(index)
                    },
                    badgeClick: function ($event) {
                      return _vm.badgeClick(index)
                    },
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.filterData,
          callback: function ($$v) {
            _vm.filterData = $$v
          },
          expression: "filterData",
        },
      }),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.$t("filter_component.add_filter"),
            "ok-title": _vm.$t("button.ok"),
            "content-class": "shadow",
            "no-close-on-backdrop": "",
          },
          on: { ok: _vm.addFilter },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function ({ ok, cancel }) {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        disabled:
                          _vm.field === null ||
                          (!Array.isArray(_vm.values) && _vm.values === "") ||
                          (Array.isArray(_vm.values) &&
                            _vm.values.filter((v) => v.checked).length === 0),
                        size: "sm",
                        variant: "success",
                      },
                      on: {
                        click: function ($event) {
                          return ok()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("button.ok")))]
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "danger" },
                      on: {
                        click: function ($event) {
                          return cancel()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.filterShow,
            callback: function ($$v) {
              _vm.filterShow = $$v
            },
            expression: "filterShow",
          },
        },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                id: "field-type",
                label: _vm.$t("filter_component.filter_field"),
              },
            },
            [
              _c("multiselect", {
                staticClass: "custom-dropdown-options enable-option-icon",
                attrs: {
                  "max-height": 300,
                  options: _vm.fields.map((i) => i.value),
                  "custom-label": _vm.getFieldOptionLabel,
                  placeholder: "",
                  searchable: false,
                  "allow-empty": false,
                  showLabels: false,
                },
                scopedSlots: _vm._u([
                  {
                    key: "option",
                    fn: function (props) {
                      return [
                        _vm.field == props.option
                          ? _c("font-awesome-icon", {
                              staticClass: "selected-option-icon",
                              attrs: { icon: ["far", "check"] },
                            })
                          : _vm._e(),
                        _c("span", { staticClass: "option__title" }, [
                          _vm._v(_vm._s(_vm.getFieldOptionLabel(props.option))),
                        ]),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.field,
                  callback: function ($$v) {
                    _vm.field = $$v
                  },
                  expression: "field",
                },
              }),
            ],
            1
          ),
          _c(
            "b-form-group",
            [
              _c("b-form-radio-group", {
                attrs: {
                  id: "radio-group-1",
                  options: _vm.operators,
                  name: "operator",
                },
                model: {
                  value: _vm.operator,
                  callback: function ($$v) {
                    _vm.operator = $$v
                  },
                  expression: "operator",
                },
              }),
            ],
            1
          ),
          Array.isArray(_vm.values)
            ? _c(
                "b-form-group",
                {
                  attrs: {
                    id: "field-value",
                    label: _vm.$t("filter_component.filter_value"),
                  },
                },
                [
                  _c(
                    "b-dropdown",
                    {
                      staticClass: "value-dropdown",
                      class:
                        _vm.filterValuesText !== ""
                          ? "notempty-value-dropdown"
                          : "",
                      attrs: { lazy: "", text: _vm.filterValuesText },
                    },
                    [
                      _vm.field &&
                      _vm.fieldValues[_vm.field] &&
                      _vm.fieldValues[_vm.field].length !== 0
                        ? _c("b-form-input", {
                            attrs: {
                              placeholder: _vm.$t("filter_component.search"),
                            },
                            model: {
                              value: _vm.listFilter,
                              callback: function ($$v) {
                                _vm.listFilter = $$v
                              },
                              expression: "listFilter",
                            },
                          })
                        : _vm._e(),
                      _c(
                        "b-dropdown-form",
                        _vm._l(_vm.values, function (value, index) {
                          return _c(
                            "b-form-checkbox",
                            {
                              key: index,
                              on: {
                                change: function ($event) {
                                  return _vm.checkboxChanged(
                                    index,
                                    ...arguments
                                  )
                                },
                              },
                              model: {
                                value: _vm.values[index].checked,
                                callback: function ($$v) {
                                  _vm.$set(_vm.values[index], "checked", $$v)
                                },
                                expression: "values[index].checked",
                              },
                            },
                            [_vm._v(_vm._s(value.text))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          !Array.isArray(_vm.values)
            ? _c(
                "b-form-group",
                { attrs: { label: _vm.$t("filter_component.filter_value") } },
                [
                  _c(
                    "b-input-group",
                    [
                      _c(
                        "b-input-group-prepend",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { id: "VAL_SUBTRACT" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.AddMinus(-1)
                                },
                              },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["far", "minus"] },
                              }),
                              _c("b-popover", {
                                attrs: {
                                  target: "VAL_SUBTRACT",
                                  placement: "top",
                                  triggers: "hover",
                                  content: _vm.$t(
                                    "task.button.duration_subtract"
                                  ),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("b-form-input", {
                        on: {
                          focusout: _vm.onFocusOut,
                          keydown: _vm.onKeyDown,
                        },
                        model: {
                          value: _vm.fieldValues[_vm.field],
                          callback: function ($$v) {
                            _vm.$set(_vm.fieldValues, _vm.field, $$v)
                          },
                          expression: "fieldValues[field]",
                        },
                      }),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { id: "VAL_ADD" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.AddMinus(1)
                                },
                              },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["far", "plus"] },
                              }),
                              _c("b-popover", {
                                attrs: {
                                  target: "VAL_ADD",
                                  placement: "top",
                                  triggers: "hover",
                                  content: _vm.$t("task.button.duration_add"),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }